const NAME = "MY_DOCUMENTS";

export default NAME;
